// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    PostRequest,
    PostRequestFromJSON,
    PostRequestToJSON,
    PostResponse,
    PostResponseFromJSON,
    PostResponseToJSON,
  } from '../models';

      export interface DeletePostRequest {
        postId: number;
      }

      export interface GetPostRequest {
        postId: number;
      }

      export interface UpdatePostRequest {
        postId: number;
        postRequest?: PostRequest;
      }


/**
* no description
*/
export interface PostsApi {
    /**
      * Delete a post
    */
    deletePost(requestParameters: DeletePostRequest): Promise<void>
    /**
      * Get a post
    */
    getPost(requestParameters: GetPostRequest): Promise<PostResponse>
    /**
      * Update a post
    */
    updatePost(requestParameters: UpdatePostRequest): Promise<PostResponse>
}

  /**
  * no description
  */
  export class PostsApiImpl extends runtime.BaseAPI implements PostsApi {

    /**
      * Delete a post
    */
    async deletePostRaw(requestParameters: DeletePostRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.postId === null || requestParameters.postId === undefined) {
          throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling deletePost.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/posts/{postId}`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Delete a post
      */
      async deletePost(requestParameters: DeletePostRequest): Promise<void> {
        await this.deletePostRaw(requestParameters);
      }

    /**
      * Get a post
    */
    async getPostRaw(requestParameters: GetPostRequest): Promise<runtime.ApiResponse<PostResponse>> {
          if (requestParameters.postId === null || requestParameters.postId === undefined) {
          throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling getPost.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/posts/{postId}`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => PostResponseFromJSON(jsonValue));
      }

      /**
        * Get a post
      */
      async getPost(requestParameters: GetPostRequest): Promise<PostResponse> {
        const response = await this.getPostRaw(requestParameters);
        return await response.value();
      }

    /**
      * Update a post
    */
    async updatePostRaw(requestParameters: UpdatePostRequest): Promise<runtime.ApiResponse<PostResponse>> {
          if (requestParameters.postId === null || requestParameters.postId === undefined) {
          throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling updatePost.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/posts/{postId}`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
              body: PostRequestToJSON(requestParameters.postRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => PostResponseFromJSON(jsonValue));
      }

      /**
        * Update a post
      */
      async updatePost(requestParameters: UpdatePostRequest): Promise<PostResponse> {
        const response = await this.updatePostRaw(requestParameters);
        return await response.value();
      }

    }
